import { render } from "./Issues.vue?vue&type=template&id=f163cdda&scoped=true"
import script from "./Issues.vue?vue&type=script&lang=js"
export * from "./Issues.vue?vue&type=script&lang=js"

import "./Issues.vue?vue&type=style&index=0&id=f163cdda&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f163cdda"]])

export default __exports__